import React, { useState, useEffect } from 'react';
import Fnc from '../library/Functions'
import Loader from "react-loader-spinner";

function PhoneInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [phoneVerified, setPhoneVerified] = useState(false);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    //checkPhone(props.phone);

  }, [props.isLogged,props.iva, props.loadData]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;
    checkPhone(val);
  }

  function checkPhone(val) {

    if (props.required) {
      //è un campo obbligatorio?

      if (val && val.length > 0) {
        //non ho un valore vuoto

        if (phoneVerified !== val) {
          //non è un valore che ho già controllato
          setLoading(true);

          let valdPhone = Fnc.gValidatePhone(val, 'IT');
          Fnc.log("GOOGLE PHONE:", valdPhone, Fnc.LogLvl.DEBUG);

          //let valdPhone = Fnc.validatePhone(val);
          if (valdPhone.code === Fnc.EnmPhone.OK) {
            //telefono formalmente valido?
            setPhoneVerified(true);
            setShowError(false);
            setErrorMsg(null);
            props.callback(valdPhone);

          } else {
            //il telefono specificato è formalmente NON valido
            setPhoneVerified(null);
            setShowError(true);
            setErrorMsg(valdPhone.code.msg);
            props.callback(valdPhone);
          }
          setLoading(false);

        }

      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmPhone.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmPhone.EMPTY));
      }

    } else {
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmPhone.OK, null));
    }

  }


  return (
    <>
      <input className="form-control"  type="text" placeholder="c " aria-labelledby="phone" key={props.phone} defaultValue={props.phone} onBlur={onBlur}></input>
      <span className={`placeholder-text ${(showError === true) && "lblError"} `}>{(props.required ? "* " : "") + "Telefono"}<Loader visible={loading} className="loadingSpinner" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></span>
      {showError === true && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default PhoneInp;
